import { STEP_TYPES } from "./constants";

const htmlIdFormat = (text) => {
  // Match the backend's html_id_format function to make the keys

  // Filter out forbidden characters
  text = text
    .split("")
    .filter(
      (char) => /[a-zA-Z0-9]/.test(char) || ["-", "_", ":", "."].includes(char),
    )
    .join("");

  // Remove leading non-alphanumeric characters
  while (text.length > 0 && !/[a-zA-Z0-9]/.test(text[0])) {
    text = text.slice(1);
  }

  return text;
};

const stripKey = (key, type) => {
  const typePrefix = type
    ? `${type.charAt(0).toUpperCase()}${type.slice(1)}`
    : "general";
  // In the typePrefix, htmlIdFormat must be used to match the key
  // e.g. "Client Contact" becomes "ClientContact"
  return key.replace(htmlIdFormat(typePrefix), "").replace("NoteType", "");
};

export const activeNoteType = (createNotesUpon, key, type) =>
  createNotesUpon.includes(stripKey(key, type));

export const filteredSettings = (settings, step, type) => {
  const stepTypeHasKey = (s, k) =>
    STEP_TYPES[s].keys.includes(stripKey(k, type));

  if (!settings) return [];
  return step === "general"
    ? settings.filter(
        (s) =>
          !Object.keys(STEP_TYPES).some(
            (k) => k !== "general" && stepTypeHasKey(k, s.key),
          ),
      )
    : settings.filter((s) => stepTypeHasKey(step, s.key));
};
